import { ReactNode, createContext, useContext } from "react";
import { useFilterTenant } from "./filter-tenant.hook";

const FilterTenantContext = createContext(
  {} as ReturnType<typeof useFilterTenant>
);
export function useFilterTenantContext() {
  return useContext(FilterTenantContext);
}

interface FilterTenantProviderProps {
  children: ReactNode;
}
export function FilterTenantProvider({
  children,
}: FilterTenantProviderProps) {
  return (
    <FilterTenantContext.Provider value={useFilterTenant()}>
      {children}
    </FilterTenantContext.Provider>
  );
}